import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

interface CSVImportSuccessProps {
  count: number;
  onViewAssets: () => void;
  onImportMore: () => void;
}

export default function CSVImportSuccess({
  count,
  onViewAssets,
  onImportMore
}: CSVImportSuccessProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 space-y-6">
      <div className="rounded-full bg-green-100 p-6">
        <CheckCircle2 className="h-16 w-16 text-green-600" />
      </div>

      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold">
          {count} asset{count !== 1 ? 's' : ''} imported successfully
        </h2>
        <p className="text-muted-foreground">
          Your assets have been added to the register
        </p>
      </div>

      <div className="flex gap-3">
        <Button onClick={onViewAssets}>
          View Imported Assets
        </Button>
        <Button variant="outline" onClick={onImportMore}>
          Import More
        </Button>
      </div>
    </div>
  );
}
